import { FC } from "react";
import classNames from "classnames";

import { ButtonRecord, IButton, ILink, ITag } from "@types";

import { Button } from "components/atoms/Button/Button";
import { Icon } from "components/atoms/Icon/Icon";
import { Pretitle } from "components/atoms/Pretitle/Pretitle";
import { Tags } from "components/atoms/Tag/Tags";
import { TranslatedLink } from "components/atoms/TranslatedLink/TranslatedLink";
import { CBButton } from "components/InlineBlocks/CBButton";

import { IconRecord, TeaserModelButtonField } from "@graphql/types/graphql";
import { StructuredText } from "components/sections/RichtextSection/StructuredText";
import s from "./Teaser.module.scss";

function isDatoButton(button: IButton | TeaserModelButtonField): button is TeaserModelButtonField {
  return "__typename" in button;
}

interface Props {
  icon?: IconRecord[];
  pretitle?: string;
  title: string;
  description: string;
  tags?: ITag[];
  button?: Array<IButton | TeaserModelButtonField>;
  isFullLink?: ILink | null;
  hasBorder?: boolean;
}

export const Teaser: FC<Props> = ({
  icon,
  pretitle,
  title,
  description,
  tags,
  button,
  isFullLink,
  hasBorder,
}) => {
  return (
    <div
      className={classNames(s.Teaser, {
        [s.HasBorder]: hasBorder,
      })}
    >
      <div className={s.Content}>
        {icon && icon.length > 0 && (
          <div className={s.Icon}>
            <Icon name={icon[0].iconName} size="xl" color="blue" background />
          </div>
        )}
        {isFullLink ? (
          <TranslatedLink link={isFullLink} className={s.Title}>
            <Pretitle pretitle={pretitle} title={title} small />
          </TranslatedLink>
        ) : (
          <div className={s.Title}>
            <Pretitle pretitle={pretitle} title={title} small />
          </div>
        )}
        {description && typeof description === "string" && (
          <div
            className={classNames(s.Description, "prose")}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {description && typeof description === "object" && (
          <div className={classNames(s.Description, "prose")}>
            <StructuredText structuredText={description as any} />
          </div>
        )}
        {tags && tags?.length > 0 && (
          <div className={s.Tags}>
            <Tags tags={tags} />
          </div>
        )}
        {button && button?.length > 0 && (
          <div className={s.Buttons}>
            {button?.map((buttonItem) =>
            isDatoButton(buttonItem) ? (
              <div key={buttonItem.id}>
                <CBButton {...(buttonItem as ButtonRecord)} />
              </div>
            ) : (
                <div key={buttonItem.label}>
                  <Button {...buttonItem} />
                </div>
              ),
            )}
          </div>
        )}
      </div>
    </div>
  );
};
